import Setup from 'views/setup/Setup';
import { Route } from '../ProtectedRoute';
import wcRoutes from './wc/wc.routes';
import wcoRoutes from './wco/wco.routes';

const setupRoutes: Route[] = [
    {
        path: 'setup',
        name: 'WeighbridgeClientOnboarding',
        element: <Setup />,
        children: [...wcoRoutes, ...wcRoutes],
    },
];

export default setupRoutes;
